function addToCartSticky() {
  const mainForm = typeof Elixir_GetProductForm === 'function' ? Elixir_GetProductForm() : null;

  if (mainForm) {
    const mainAtcBtn = mainForm.querySelector('button[name="add"], button[type="submit"], input[type="submit"]');
    if (mainAtcBtn) {
      mainAtcBtn.click();
    } else {
      mainForm.requestSubmit();
    }
  } else {
    console.warn('Main product form not found.');
  }
}

document.addEventListener('DOMContentLoaded', function () {
  const selects = document.querySelectorAll('.sticky-variant-select');
  const hiddenInput = document.getElementById('sticky-variant-id');
  const stickyConfig = JSON.parse(document.getElementById('sticky-atc-config')?.textContent || '{}');
  const variants = stickyConfig.variants || [];
  const optionCount = stickyConfig.optionCount || 0;

  const buttonTextStr = stickyConfig.buttonText;
  const soldOutTextStr = stickyConfig.soldOutText;

  // Anti-loop flag for Variant Bundle
  let isSyncingVariantBundle = false;

  // ==========================================
  // VARIANT SYNC & UI LOGIC
  // ==========================================

  function updateStickyButtonState(variant) {
    const atcButtons = document.querySelectorAll('.sticky-add-to-cart__button');

    if (variant && variant.available) {
      atcButtons.forEach(btn => {
        btn.disabled = false;
        btn.classList.remove('is-disabled');
        const textSpan = btn.querySelector('.button-text');
        if (textSpan) textSpan.textContent = buttonTextStr;
      });
    } else {
      atcButtons.forEach(btn => {
        btn.disabled = true;
        btn.classList.add('is-disabled');
        const textSpan = btn.querySelector('.button-text');
        if (textSpan) textSpan.textContent = soldOutTextStr;
      });
    }
  }

  function updateStickyImage(variant) {
    if (variant && variant.featured_image && variant.featured_image.src) {
      const stickyImages = document.querySelectorAll('.sticky-add-to-cart__image img');

      let newSrc = variant.featured_image.src;
      if (newSrc.startsWith('//')) {
        newSrc = 'https:' + newSrc;
      }

      stickyImages.forEach(img => {
        img.src = newSrc;
        if (img.srcset) {
          img.srcset = newSrc;
        }
      });
    }
  }

  function syncSimpleVariantPicker(variant) {
    if (!variant) return;

    for (let i = 1; i <= 3; i++) {
      const optionValue = variant[`option${i}`];
      if (!optionValue) continue;

      const escapedVal = optionValue.replace(/"/g, '\\"');

      const radio = document.querySelector(`.simple-variant-picker__radio[data-option-position="${i}"][value="${escapedVal}"]`);
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const select = document.querySelector(`.simple-variant-picker__select[data-option-position="${i}"]`);
      if (select && select.value !== optionValue) {
        select.value = optionValue;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  function updateStickyVariant() {
    if (selects.length === 0) return;

    const selectedOptions = [];
    for (let i = 1; i <= optionCount; i++) {
      const select = document.querySelector(`.sticky-variant-select[data-option-index="${i}"]`);
      if (select) selectedOptions.push(select.value);
    }

    const matchedVariant = variants.find(variant =>
      variant.options.every((opt, idx) => opt === selectedOptions[idx])
    );

    if (matchedVariant) {
      if (hiddenInput) {
        hiddenInput.value = matchedVariant.id;
      }

      if (typeof window.Elixir_SetProductFormVariantId === 'function') {
        window.Elixir_SetProductFormVariantId(matchedVariant.id);
      }

      updateStickyButtonState(matchedVariant);
      updateStickyImage(matchedVariant);
      syncSimpleVariantPicker(matchedVariant);

      // Sync TO Variant Bundle
      if (!isSyncingVariantBundle) {
        const bundleCard = document.querySelector(`.variant-product-card[data-variant-id="${matchedVariant.id}"]`);
        if (bundleCard) {
          if (!bundleCard.classList.contains('selected')) {
            isSyncingVariantBundle = true;
            bundleCard.click();
            setTimeout(() => { isSyncingVariantBundle = false; }, 50);
          }
        } else {
          document.querySelectorAll('.variant-product-card').forEach(card => {
            card.classList.remove('selected');
          });
        }
      }
    }
  }

  selects.forEach(select => {
    select.addEventListener('change', function(e) {
      const optionIndex = this.dataset.optionIndex;
      const optionValue = this.value;

      // Sync Desktop <-> Mobile sticky bar dropdowns
      document.querySelectorAll(`.sticky-variant-select[data-option-index="${optionIndex}"]`).forEach(s => {
        if (s !== this) s.value = optionValue;
      });

      updateStickyVariant(); 
      this.blur(); 

      if (e.detail && e.detail.isSync) return;

      // Sync with the Simple Variant Picker
      const svpRadio = document.querySelector(`.simple-variant-picker__radio[data-option-position="${optionIndex}"][value="${optionValue.replace(/"/g, '\\"')}"]`);
      if (svpRadio && !svpRadio.disabled) {
        svpRadio.checked = true;
        svpRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }

      const svpSelect = document.querySelector(`.simple-variant-picker__select[data-option-position="${optionIndex}"]`);
      if (svpSelect) {
        svpSelect.value = optionValue;
        svpSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });

  // --- Sync FROM Simple Variant Picker ---
  document.addEventListener('simple-variant-picker:variantChange', function(e) {
    const detailVariant = e.detail && e.detail.variant;
    if (!detailVariant) return;
    // Some pickers (e.g. variant cards) send only id and prices, without availability or options.
    const variant = variants.find(v => String(v.id) === String(detailVariant.id)) || detailVariant;

    if (hiddenInput) {
      hiddenInput.value = variant.id;
    }

    updateStickyButtonState(variant);
    updateStickyImage(variant);

    if (selects.length > 0 && variant.options) {
      variant.options.forEach((optionValue, index) => {
        const targetSelects = document.querySelectorAll(`.sticky-variant-select[data-option-index="${index + 1}"]`);
        targetSelects.forEach(targetSelect => {
          if (targetSelect && targetSelect.value !== optionValue) {
            targetSelect.value = optionValue;
          }
        });
      });
    }
  });

  // --- Sync FROM Variant Bundle ---
  document.addEventListener('click', function(e) {
    const variantCard = e.target.closest('.variant-product-card');
    if (variantCard && !isSyncingVariantBundle) {
      const variantId = variantCard.getAttribute('data-variant-id');
      if (variantId) {
        const matchedVariant = variants.find(v => v.id.toString() === variantId.toString());
        if (matchedVariant) {
          isSyncingVariantBundle = true;

          if (matchedVariant.options) {
            matchedVariant.options.forEach((optionValue, index) => {
              const targetSelects = document.querySelectorAll(`.sticky-variant-select[data-option-index="${index + 1}"]`);
              targetSelects.forEach(s => {
                s.value = optionValue;
              });
            });
          }

          updateStickyVariant();
          setTimeout(() => { isSyncingVariantBundle = false; }, 50);
        }
      }
    }
  });

  // ==========================================
  // QUANTITY SYNC LOGIC
  // ==========================================

  function updateStickyUIQuantity(qty) {
    const stickyInputs = document.querySelectorAll('.sticky-qty-input');
    stickyInputs.forEach(input => {
      if (parseInt(input.value) !== qty) {
        input.value = qty;
      }
    });
  }

  function handleStickyQuantityAction(newQty) {
    updateStickyUIQuantity(newQty);

    const mainForm = typeof window.Elixir_GetProductForm === 'function' ? window.Elixir_GetProductForm() : null;
    if (mainForm) {
      let mainQtyInput = mainForm.querySelector('input[name="quantity"]');
      if (!mainQtyInput) {
        mainQtyInput = document.createElement('input');
        mainQtyInput.type = 'hidden';
        mainQtyInput.name = 'quantity';
        mainForm.appendChild(mainQtyInput);
      }
      if (parseInt(mainQtyInput.value) !== newQty) {
        mainQtyInput.value = newQty;
        mainQtyInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    // Sync TO Quantity Break
    const qbInput = document.querySelector(`.quantity-break-input[value="${newQty}"]`);
    if (qbInput) {
      const qbOption = qbInput.closest('.quantity-break-option');
      if (qbOption && !qbOption.classList.contains('selected')) {
        qbOption.click();
      }
    } else {
      document.querySelectorAll('.quantity-break-option.selected').forEach(opt => {
        opt.classList.remove('selected');
      });
    }

    // Sync TO Quantity Bundle
    const bundleCard = document.querySelector(`.quantity-bundle-card[data-quantity="${newQty}"]`);
    if (bundleCard) {
      if (bundleCard.getAttribute('data-selected') !== 'true') {
        bundleCard.click();
      }
    } else {
      document.querySelectorAll('.quantity-bundle-card[data-selected="true"]').forEach(card => {
        card.setAttribute('data-selected', 'false');
        const radio = card.querySelector('.quantity-bundle-radio');
        if (radio) radio.checked = false;
      });
    }
  }

  document.querySelectorAll('.sticky-qty-minus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.nextElementSibling;
      let val = parseInt(input.value) || 1;
      if (val > 1) {
        handleStickyQuantityAction(val - 1);
      }
    });
  });

  document.querySelectorAll('.sticky-qty-plus').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.previousElementSibling;
      let val = parseInt(input.value) || 1;
      handleStickyQuantityAction(val + 1);
    });
  });

  document.querySelectorAll('.sticky-qty-input').forEach(input => {
    input.addEventListener('change', () => {
      let val = parseInt(input.value) || 1;
      if (val < 1) val = 1;
      handleStickyQuantityAction(val);
    });
  });

  // Sync FROM Quantity Bundle TO Sticky Bar
  document.addEventListener('quantity:changed', function(e) {
    if (e.detail && e.detail.quantity) {
      updateStickyUIQuantity(e.detail.quantity);
    }
  });

  // Sync FROM Quantity Break TO Sticky Bar
  document.addEventListener('quantity_break:changed', function(e) {
    if (e.detail && e.detail.quantity) {
      updateStickyUIQuantity(e.detail.quantity);
    }
  });

  // ==========================================
  // INITIALIZATION ON LOAD
  // ==========================================

  setTimeout(() => {
    // Initial Variant Sync
    const checkedRadios = document.querySelectorAll('.simple-variant-picker__radio:checked');
    checkedRadios.forEach(radio => {
      const index = radio.dataset.optionPosition;
      document.querySelectorAll(`.sticky-variant-select[data-option-index="${index}"]`).forEach(targetSelect => {
        targetSelect.value = radio.value;
      });
    });

    const selectedDropdowns = document.querySelectorAll('.simple-variant-picker__select');
    selectedDropdowns.forEach(dropdown => {
      const index = dropdown.dataset.optionPosition;
      if (dropdown.value) {
        document.querySelectorAll(`.sticky-variant-select[data-option-index="${index}"]`).forEach(targetSelect => {
          targetSelect.value = dropdown.value;
        });
      }
    });

    // Check if Variant Bundle has an initial selection
    const preselectedVariantCard = document.querySelector('.variant-product-card.selected');
    if (preselectedVariantCard && !isSyncingVariantBundle) {
      const variantId = preselectedVariantCard.getAttribute('data-variant-id');
      if (variantId) {
        const matchedVariant = variants.find(v => v.id.toString() === variantId.toString());
        if (matchedVariant && matchedVariant.options) {
          matchedVariant.options.forEach((optionValue, index) => {
            const targetSelects = document.querySelectorAll(`.sticky-variant-select[data-option-index="${index + 1}"]`);
            targetSelects.forEach(s => { s.value = optionValue; });
          });
        }
      }
    }

    updateStickyVariant();

    // Initial Quantity Sync
    let initialQty = null;

    const preselectedBundle = document.querySelector('.quantity-bundle-card[data-selected="true"]');
    if (preselectedBundle) {
      initialQty = parseInt(preselectedBundle.getAttribute('data-quantity'), 10);
    } else {
      const preselectedBreak = document.querySelector('.quantity-break-option.selected input.quantity-break-input');
      if (preselectedBreak) {
        initialQty = parseInt(preselectedBreak.value, 10);
      }
    }

    if (initialQty && !isNaN(initialQty)) {
      handleStickyQuantityAction(initialQty); 
    }
  }, 250);

  // ==========================================
  // DELIVERY DATES
  // ==========================================

  const deliveryDateElements = document.querySelectorAll('.delivery-date[data-timestamp]');

  deliveryDateElements.forEach(function(element) {
    try {
      const timestamp = parseInt(element.dataset.timestamp, 10) * 1000;
      const locale = element.dataset.locale || 'en';
      const format = element.dataset.format || 'weekday_month_day';
      const jsDate = new Date(timestamp);

      let options = {};
      switch (format) {
        case 'weekday_month_day':
          options = { weekday: 'long', month: 'long', day: 'numeric' };
          break;
        case 'month_day_weekday':
          options = { month: 'long', day: 'numeric', weekday: 'long' };
          break;
        case 'month_day':
          options = { month: 'long', day: 'numeric' };
          break;
        case 'day_month':
          options = { day: 'numeric', month: 'long' };
          break;
        default:
          options = { weekday: 'long', month: 'long', day: 'numeric' };
      }

      const formatter = new Intl.DateTimeFormat(locale, options);
      let formattedDate = formatter.format(jsDate);

      if (format === 'month_day_weekday') {
        const parts = formatter.formatToParts(jsDate);
        const weekday = parts.find(part => part.type === 'weekday')?.value;
        const month = parts.find(part => part.type === 'month')?.value;
        const day = parts.find(part => part.type === 'day')?.value;
        if (weekday && month && day) {
          formattedDate = `${month} ${day}, ${weekday}`;
        }
      }

      element.textContent = formattedDate;
    } catch (error) {
      console.error('Error formatting delivery date:', error);
      const timestamp = parseInt(element.dataset.timestamp, 10) * 1000;
      const jsDate = new Date(timestamp);
      element.textContent = jsDate.toLocaleDateString();
    }
  });

});
